import type {
	CustomItem,
	DropMadcCarouselType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropMadcCarousel = (
	item: Item | CustomItem
): item is DropMadcCarouselType => {
	return !!(
		item &&
		item.__typename === 'Drop_Custom_Component' &&
		item.name === 'MadC_Carousel_With_Works'
	);
};
